import { useEffect } from 'react';

type IntervalOptions = {
  callback: () => void;
  ms: number;
  intervalTrigger?: unknown;
  skip?: boolean;
  dependencies?: unknown[];
};

export const useInterval = ({
  callback,
  ms,
  intervalTrigger,
  skip,
  dependencies = [],
}: IntervalOptions) => {
  useEffect(() => {
    const interval = setInterval(() => {
      if (skip) return;

      callback();
    }, ms);

    return () => {
      clearInterval(interval);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [intervalTrigger, skip, ...dependencies]);
};
